import { useEffect, useState } from 'react';
import { LocationPractitioner, LocationsApi } from '~/api';
import { getBaseUrl } from '~/env';
export const useCachedFetch = (clinicLocationGuid: string) => {
  const [data, setData] = useState<LocationPractitioner[]>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    setError(false);
    try {
      const api = new LocationsApi({ baseUrl: getBaseUrl() });
      const response = await api.getPractitionerAtLocation(
        clinicLocationGuid,
        undefined,
        {
          cache: 'force-cache',
        }
      );
      const responseData = await response.json();
      setData(responseData.practitioners);
    } catch (error: unknown) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicLocationGuid]);

  return { data, loading, error, fetchData };
};
